// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mXXn","colBig":"styles_colBig__1lImd","colSmall":"styles_colSmall__3IKQI","shopifyNameWrapper":"styles_shopifyNameWrapper__140xF"};